import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchApplicationCodes(ctx, queryParams) {
        return new Promise((resolve, reject) => {
          axiosIns.get('/application_code/list', {params:queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
    },
    fetchApplicationCode(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`/application_code/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    addApplicationCode(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/application_code', data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    }

  },
}
